'use client';
import { useState, useEffect } from 'react';
import './MyAppointments.scss';
import 'react-phone-input-2/lib/style.css';
import DcoumentiMG from '@/assets/img/v2/document.png';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { useGetAppointments } from '../api/getAppointments';
import { useAuth } from '@/lib/auth';
import Lottie from 'lottie-react';
import { Appointments, Order } from '../types';
import Utils from '@/utils/util';
import { TransactionList } from '../components/TransactionList';
import { Tabs } from '../../../components/Tab/Tab';
import { ReactComponent as Payment } from '../../../assets/img/pay-status.svg';
import DeleteIcon, {
  ReactComponent as DeleteIconSvg,
} from '../../../assets/img/delete-icon-v2.svg';

import BackIcon from '@/assets/img/back-icon.svg';
import PetsIcon, { ReactComponent as PetsIcons } from '@/assets/img/profile-pic.svg';
import CatDefaultIcon from '@/assets/img/v2/pet-cat-default-icon.svg';
import DogDefaultIcon from '@/assets/img/v2/pet-dog-default-icon.svg';
import { ArchiveIcon } from '@heroicons/react/outline';
import DownArrow from '@/assets/img/down-arrow.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import ConfirmationDialogV2 from '../../../components/ConfirmationDialog/ConfirmationDialogV2';
import { useGetRefundDetails } from '../api/getRefundDetails';
import { TableData } from '../../../components/Table/TableData';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import appCompoLoading from '@/assets/animation/loading.json';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { ActionMenu } from '@/components/ActionMenu';
import { useDeleteService } from '../api/deleteAppointment';
import PaymentRequest from '../components/PaymentRequest';
import { MobileView } from 'react-device-detect';
import { AppointmentMobileView } from '@/components/AppointmentMobileView/AppointmentMobileView';
import { Button } from '../../../components/Button';
import PaymentCompletedModal from '../components/PaymentCompletedModal';
import { UseScreenOrientation } from '@/utils/Orientation';
import PAYMENT_TYPES from '@/config/constants';
import BoardingPetInfo from '../components/BoardingPetInfo';
import { LineItem } from '../api/updatePayment';

import { useTranslation } from 'react-i18next';
export default function MyAppointments() {
  const isLandscape = UseScreenOrientation();
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 50;
  const [selectedPage, setSelectedPage] = useState(1);
  const { user } = useAuth();
  const { t } = useTranslation();
  const deleteDiscussionMutation = useDeleteService();
  const useGetEventsMutation = useGetAppointments();
  const [events, setEvents] = useState<Appointments[]>();
  const [isCancelled, setCancelled] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState<Appointments>();
  const [openTrxModal, setOpenTrxModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState(3);
  const [hideRefundStatus, setHideRefundStatus] = useState(false);
  const getRefundMutation = useGetRefundDetails();
  const [refundDetails, setRefundDetails] = useState<any>();
  const [showPaymentDialog, setPaymentDialog] = useState(false);
  const [showPaymentCompletedModal, setShowPaymentCompletedModal] = useState(false);
  const [reviewMsg, setReviewMsg] = useState('');
  const [selectedApptlineItem, setSelectedApptlineItem] = useState<LineItem>();
  const [isRoomBooking] = useState(
    window.location.pathname.indexOf('my-appointments') >= 0 ? false : true
  );
  const [advancedPayment, setAdvancedPayment] = useState(0);
  const handleTextareaChange = (event: any) => {
    setReviewMsg(event.target.value);
  };
  console.log(window.location);

  const tabs = [
    {
      label: t('Requested'),
      show: true,
      mobilelabel: t('Requested Appointments'),
    },
    {
      label: t('Accepted'),
      show: true,
      mobilelabel: t('Accepted Appointments'),
    },
    {
      label: t('Completed'),
      show: true,
      mobilelabel: t('Completed Appointments'),
    },
    {
      label: t('Rejected'),
      show: true,
      mobilelabel: t('Rejected Appointments'),
    },
  ];

  useEffect(() => {
    fetchEvents();
  }, [selectedPage, selectedTab]);
  const fetchEvents = async () => {
    const res = await useGetEventsMutation.mutateAsync({
      businessId: user?.businessId,
      page: selectedPage,
      perPage: perPage,
      type: selectedTab,
      isRoomBooking,
    });
    setTotalPages(res.totalPages);
    setEvents(res.list);
  };

  const onTableStateChange = (pageIndex: number) => {
    fetchEvents();
  };
  const handlePageClick = async (event: any) => {
    setSelectedPage(event.selected + 1);
  };

  const onTabChange = (index: number) => {
    setEvents(undefined);
    if (index === 0) {
      setSelectedTab(3);
    }
    if (index === 1) {
      setSelectedTab(0);
    }
    if (index === 2) {
      setSelectedTab(1);
    }
    if (index === 3) {
      setSelectedTab(2);
    }
  };

  const onEditClicked = (event: Appointments) => {
    // if(event && event?.orders && event.orders.length>1){
    //  setOpenTrxModal(true);
    //if (event && event?.orders && event.orders.length === 1) {
    setPaymentDialog(true);
    // }
    setSelectedAppointment(event);
  };

  const onCancelAppointment = async (event: Appointments) => {
    setSelectedAppointment(event);
    setCancelled(true);
    if (selectedTab === 3) {
      setHideRefundStatus(true);
    }

    const resp = await getRefundMutation.mutateAsync({
      appointmentId: event?.id,
      roomId: event.room ? event.room.id : undefined,
    });
    setRefundDetails(resp);
    setCancelled(true);
  };
  const getAppointmentOption = (event: Appointments) => {
    const optionArray = [];
    if (selectedTab == 0) {
      optionArray.push({
        label: t('Payment'),
        icon: Payment,
        onClickHandler: () => onEditClicked(event),
        itemClassName: '',
      });
    }
    if (event.orders && event.orders.length && selectedTab == 1) {
      optionArray.push({
        label: t('Payment'),
        icon: Payment,
        onClickHandler: () => onEditClicked(event),
        itemClassName: '',
      });
    }
    if (selectedTab == 0) {
      optionArray.push({
        label: t('Cancel'),
        icon: DeleteIconSvg,
        onClickHandler: () => onCancelAppointment(event),
        itemClassName: '',
      });
    }

    return optionArray && optionArray.length > 0 ? optionArray : [];
  };

  const onDialogClosed = (refresh = false) => {
    setCancelled(false);
    setSelectedAppointment(undefined);
    setHideRefundStatus(false);
    setRefundDetails(undefined);
  };
  const onDeleteConfirmed = async () => {
    if (selectedAppointment) {
      await deleteDiscussionMutation.mutateAsync({
        data: selectedAppointment,
        requestedAppointment: selectedTab === 3 ? true : false,
        rejectNote: reviewMsg,
        roomId: selectedAppointment?.room?.id
      });
      setCancelled(false);
      setSelectedAppointment(undefined);
      setHideRefundStatus(false);
      setRefundDetails(undefined);
      fetchEvents();
    }
  };

  const onDialogClosedTrx = (refresh = false) => {
    setOpenTrxModal(false);
    setSelectedAppointment(undefined);
    setPaymentDialog(false);
  };
  const onDeleteConfirmedTrx = async () => {
    if (selectedAppointment) {
      await deleteDiscussionMutation.mutateAsync({
        data: selectedAppointment,
        requestedAppointment: selectedTab === 3 ? true : false,
        rejectNote: reviewMsg,
      });
    }
  };

  const getSelectedTabs = () => {
    if (selectedTab === 3) {
      return t('Requested Appointments');
    }
    if (selectedTab === 2) {
      return t('Rejected Appointments');
    }
    if (selectedTab === 1) {
      return t('Completed Appointments');
    }
    if (selectedTab === 0) {
      return t('Accepted Appointments');
    }
  };
  const onBackToList = () => {
    setCancelled(false);
    setSelectedAppointment(undefined);
    setHideRefundStatus(false);
    setRefundDetails(undefined);
    setPaymentDialog(false);
  };

  useEffect(() => {
    const advPay = getAdvancePayment();
    setAdvancedPayment(advPay);
  }, [selectedAppointment]);

  const getAdvancePayment = () => {
    let amount = 0;
    if (selectedAppointment && selectedAppointment?.orders && selectedAppointment?.orders) {
      selectedAppointment?.orders.map((o: Order) => {
        if (o.isAdvancePayment) {
          amount += Number(o.paymentAmount);
        }
      });
    }
    return amount;
  };
  const getPaymentStatus = (item: Order) => {
    if (PAYMENT_TYPES.FAILURE.indexOf(item.paymentStatus || '') >= 0) {
      return t('Failure');
    }

    if (PAYMENT_TYPES.SUCCESS.indexOf(item.paymentStatus || '') >= 0) {
      return t('Success');
    }

    return t('Pending');
  };

  const getPaymentAmmount = (item: Order) => {
    if (item?.refundMetaData?.percentage) {
      const amt = (Number(item?.refundMetaData?.percentage) * Number(item.paymentAmount)) / 100;
      return `$${Number(item.paymentAmount).toFixed(2)} (${
        Number(item?.refundMetaData?.percentage) >= 100
          ? `${t('Refunded')} $${Number(amt).toFixed(2)}`
          : `${t('Partial Refunded')} $${Number(amt).toFixed(2)}`
      })`;
    }

    return `$${Number(item.paymentAmount).toFixed(2)}`;
  };

  const trx = selectedAppointment && selectedAppointment?.orders && selectedAppointment?.orders[0];
  const getVisisbleHeaderStatus = () => {
    if (!isLandscape && (showPaymentDialog || showPaymentCompletedModal)) {
      return false;
    } else if (!isLandscape && isCancelled) {
      return false;
    } else {
      return true;
    }
  };

  const getActionDetails = (event: any) => {
    if (
      selectedTab == 1 &&
      event?.orders &&
      event?.orders[0] &&
      getPaymentStatus(event?.orders[0]) === 'Pending' &&
      event?.orders[0].paymentLink
    ) {
      return (
        <a href={event?.orders[0].paymentLink} target="_blank" rel="noreferrer">
          <div
            className="pay-now-btn-div"
            onClick={async () => {
              if (event?.orders && event?.orders.length > 0) {
                fetchEvents();
                setPaymentDialog(false);
              }
            }}
          >
            {t('Pay')}
          </div>
        </a>
      );
    } else if (
      selectedTab == 1 &&
      event?.orders &&
      event?.orders[0] &&
      getPaymentStatus(event?.orders[0]) === 'Success'
    ) {
      return (
        <img
          src={DcoumentiMG}
          className="document-image-div"
          onClick={() => {
            setShowPaymentCompletedModal(true);
            setSelectedAppointment(event);
          }}
        />
      );
    } else if (getAppointmentOption(event) && getAppointmentOption(event).length > 0) {
      return <ActionMenu options={getAppointmentOption(event)} />;
    } else {
      return null;
    }
  };

  const getPaymentSucceedStatus = (appointment: any) => {
    const orders =
      appointment && appointment.orders && appointment.orders.length > 0 ? appointment.orders : [];
    const totalAmount: any =
      orders && orders.length > 0
        ? orders.reduce(
            (sum: number, order: { paymentAmount: string }) =>
              sum + parseFloat(order?.paymentAmount),
            0
          )
        : 0;

    return Math.round(totalAmount) >= Number(appointment?.service?.price) ? true : false;
  };

  return (
    <section className="petsked-container-bg my-appointments">
      {getVisisbleHeaderStatus() ? (
        <PetskedTitle
          title={t("Your")}
          highlightTitle={isRoomBooking ? t('bookings') : t('appointments')}
          size="lg"
          alignText="left"
          description=""
          removeBgcolor={!isLandscape ? 'remove-bg-white' : ''}
        />
      ) : (
        <BackNav onClick={() => {}} />
      )}

      {!isLandscape && !isCancelled && !showPaymentDialog && !showPaymentCompletedModal ? (
        <div className="tab-details">
          <Dropdown className="new-figma-drop-down drodpdwon-btn-pink">
            <Dropdown.Toggle
              variant="success"
              className="drop-down-btn dropdown-toggle btn btn-success"
              id="dropdown-basic"
            >
              {getSelectedTabs()}
              <img src={DownArrow} className="down-arrow" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {tabs &&
                tabs?.map((item, index) => {
                  return (
                    <Dropdown.Item
                      onClick={() => {
                        onTabChange(index);
                      }}
                    >
                      <div className="menu-item-minutes">{item.mobilelabel} </div>
                    </Dropdown.Item>
                  );
                })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : (
        <>
          {!!isLandscape && (
            <div className="tab-details">
              <Tabs selectedTabIndex={0} onChange={onTabChange} tabs={tabs} />{' '}
            </div>
          )}{' '}
        </>
      )}

      <div className="owner-list petsked-table mt-10 appointment-list">
        {!isLandscape && !isCancelled && !showPaymentDialog && !showPaymentCompletedModal ? (
          <div>
            {events &&
              events.length > 0 &&
              events.map((data) => {
                return (
                  <AppointmentMobileView
                    data={data}
                    onCancelAppointment={(data: Appointments) => onCancelAppointment(data)}
                    getAppointmentOption={getAppointmentOption(data)}
                    selectedTab={selectedTab}
                  />
                );
              })}
            {events && events.length == 0 && !useGetEventsMutation.isLoading && (
              <div className="flex flex-col items-center justify-center text-gray-500 bg-white h-80">
                <ArchiveIcon className="w-16 h-16" />
                <h4 className="no-enteries">{t('No Entries Found')}</h4>
              </div>
            )}
          </div>
        ) : (
          <>
            {!useGetEventsMutation.isLoading && !!isLandscape && (
              <TableData<Appointments>
                data={events}
                columns={
                  isRoomBooking
                    ? [
                        {
                          title: t('PET DETAIL'),
                          field: 'pet',
                          Cell({ entry: item }) {
                            const petData = item.pet
                              ? [item.pet]
                              : item.pets && item.pets.length > 0
                              ? item.pets
                              : [];
                            if (!petData) return <span />;
                            return (
                              <BoardingPetInfo
                                data={petData}
                                accomodationType={item.accomodationType}
                              />
                            );
                          },
                        },
                       
                        // {
                        //   title: 'ID',
                        //   field: 'id',
                        //   Cell({ entry: { id } }) {
                        //     return <div className="pet-service">{id}</div>;
                        //   },
                        // },

                        {
                          title: t('STORE'),
                          field: 'petParent',
                          Cell({ entry: { businessLocation } }) {
                            return <div className="petParnet-name">{businessLocation?.name}</div>;
                          },
                        },
                        {
                          title: t('Booked time'),
                          field: 'startTime',
                          Cell({ entry: { startTime, endTime, businessLocation } }) {
                            return (
                              <>
                                <div className="owner-detail t-col-4">
                                  <div className="owner-name">
                                    {Utils.formatDateStringTz(
                                      startTime,
                                      businessLocation?.timezone,
                                      "DD MMM 'yy, hh:mma "
                                    )}{' '}
                                    -
                                  </div>
                                  <div className="owner-name">
                                    {Utils.formatDateStringTz(
                                      endTime,
                                      businessLocation?.timezone,
                                      "DD MMM 'yy, hh:mma "
                                    )}
                                  </div>
                                </div>
                              </>
                            );
                          },
                        },
                        {
                          title: 'Duration',
                          field: 'duration',
                          Cell({ entry:  data}) {
                            return <div className="petParnet-name">{data.accomodationType === 'boarding'
                            ? parseInt(data?.duration) > 1 ? data.duration + ' Days' : data.duration + ' Day' 
                            : Utils.getDurationDiff(data.startTime, data.endTime)}</div>;
                          },
                        },
                        // {
                        //   title: 'Check-out TIME',
                        //   field: 'endTime',
                        //   Cell({ entry: { startTime, endTime, businessLocation } }) {
                        //     return (
                        //       <>
                        //         <div className="owner-detail t-col-4">
                        //           <div className="owner-name">
                        //             {Utils.formatDateStringTz(
                        //               endTime,
                        //               businessLocation?.timezone,
                        //               "DD MMM 'yy, HH:mm a "
                        //             )}
                        //           </div>
                        //         </div>
                        //       </>
                        //     );
                        //   },
                        // },
                        {
                          title: t('Rejection note'),
                          field: 'rejectNote',
                          Cell({ entry: { rejectNote } }) {
                            return (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="tooltip-id">{rejectNote}</Tooltip>}
                              >
                                <span className="tooltip-owner-name">{rejectNote} </span>
                              </OverlayTrigger>
                            );
                          },
                          hide: selectedTab !== 2 ? true : false,
                        },

                        {
                          title: t('Action'),
                          field: 'approvalStatus',
                          Cell({ entry: event }) {
                            return selectedTab == 3 ? (
                              <div className="image-div">
                                <img src={DeleteIcon} onClick={() => onCancelAppointment(event)} />
                              </div>
                            ) : (
                              <>{getActionDetails(event)}</>
                            );
                          },
                          hide: selectedTab == 2 ? true : false,
                        },
                      ]
                    : [
                        {
                          title: t('PET DETAIL'),
                          field: 'pet',
                          Cell({ entry: item }) {
                            const petData = item.pet
                              ? item.pet
                              : item.pets && item.pets.length
                              ? item.pets[0]
                              : undefined;
                            if (!petData) return <span />;

                            return (
                              <div className={`pet-info small`}>
                                <div className="pet-profile-appointment">
                                  {petData?.petsImageUrl ? (
                                    <img src={petData?.petsImageUrl} alt="pet icon" />
                                  ) : (
                                    <img
                                      src={
                                        petData?.petType?.toLowerCase() == 'cat' ? CatDefaultIcon : DogDefaultIcon
                                      }
                                      alt="pet icon"
                                    />
                                  )}
                                </div>
                                <div className="pet-details">
                                  {petData?.name && <p className="pet-name">{petData?.name}</p>}
                                  {petData?.breed && <p className="pet-breed">{petData?.breed}</p>}
                                </div>
                              </div>
                            );
                          },
                        },
                        {
                          title: t('SERVICE BOOKED'),
                          field: 'service',
                          Cell({ entry: { service, summary } }) {
                            return <div className="pet-service">{service?.name}</div>;
                          },
                        },
                        // {
                        //   title: 'ID',
                        //   field: 'id',
                        //   Cell({ entry: { id } }) {
                        //     return <div className="pet-service">{id}</div>;
                        //   },
                        // },

                        {
                          title: t('STORE'),
                          field: 'petParent',
                          Cell({ entry: { businessLocation } }) {
                            return <div className="petParnet-name">{businessLocation?.name}</div>;
                          },
                        },
                        {
                          title: t('APPOINTMENT TIME'),
                          field: 'startTime',
                          Cell({ entry: { startTime, endTime, businessLocation } }) {
                            return (
                              <>
                                <div className="owner-detail t-col-4">
                                  <div className="owner-name">
                                    {Utils.formatDateStringTz(startTime, businessLocation.timezone)}

                                    {selectedTab !== 2 && ` | `}
                                    {selectedTab !== 2 &&
                                      `${Utils.formatDateStringTz(
                                        startTime,
                                        businessLocation.timezone,
                                        'hh:mma'
                                      )} - ${Utils.formatDateStringTz(
                                        endTime,
                                        businessLocation.timezone,
                                        'hh:mma'
                                      )}`}
                                  </div>
                                </div>
                              </>
                            );
                          },
                        },
                        {
                          title: t('Rejection note'),
                          field: 'rejectNote',
                          Cell({ entry: { rejectNote } }) {
                            return (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="tooltip-id">{rejectNote}</Tooltip>}
                              >
                                <span className="tooltip-owner-name">{rejectNote} </span>
                              </OverlayTrigger>
                            );
                          },
                          hide: selectedTab !== 2 ? true : false,
                        },

                        {
                          title: t('Action'),
                          field: 'approvalStatus',
                          Cell({ entry: event }) {
                            return selectedTab == 3 ? (
                              <div className="image-div">
                                <img src={DeleteIcon} onClick={() => onCancelAppointment(event)} />
                              </div>
                            ) : (
                              <>{getActionDetails(event)}</>
                            );
                          },
                          hide: selectedTab == 2 ? true : false,
                        },
                      ]
                }
                tableInitialState={{
                  tableTotalRecords: totalPages,
                  tablePageIndex: selectedPage,
                }}
                onTableStateChange={onTableStateChange}
                isDataLoading={useGetEventsMutation.isLoading}
              />
            )}
          </>
        )}
        {useGetEventsMutation.isLoading && (
          <div className="h-full w-full flex items-center justify-center loader-animation-user appointment-loading-height">
            <Lottie className="hw-60" animationData={appCompoLoading} />
          </div>
        )}
        {!isLandscape ? (
          <MobileView>
            {selectedAppointment && isCancelled && (
              <>
                <div className="back-nav-new" onClick={onBackToList}>
                  <img src={BackIcon} alt="back icon" />
                  <span>{t('Back')}</span>
                </div>
                <PetskedTitle
                  title={t("Cancel appointment?")}
                  highlightTitle=""
                  size="lg"
                  alignText="left"
                  description={t("Are you sure you want to cancel this appointment?")}
                />
                {!hideRefundStatus && (
                  <div className="remove-member-confirmation mobile refund-tabdetails">
                    <div className="message">{t('Refund policy')}</div>
                    <div className="refund-status">
                      {hideRefundStatus
                        ? ''
                        : refundDetails?.refundAmount
                        ? `${t('You will receive a refund of')} $${refundDetails?.refundAmount}, ${t('and it will take 5-10 days to appear on your statement.')}`
                        : t('You will not get any refund')}
                    </div>
                  </div>
                )}
                <div className="remove-member-confirmation1">
                  <p className="message">{t('Why this request is been cancelled?')}</p>
                  <textarea
                    id="description"
                    value={reviewMsg}
                    className="textarea-desc"
                    rows={5}
                    placeholder={t("Add Note...")}
                    maxLength={300}
                    onChange={handleTextareaChange}
                  />
                </div>
                <div className="mobile-btn-div">
                  <Button
                    variant="inverse"
                    size="lg"
                    onClick={onBackToList}
                    className="apt-cancel-btn"
                  >
                    {t('Cancel')}
                  </Button>
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={onDeleteConfirmed}
                    className="apt-cancel-btn"
                  >
                    {t('Confirm')}
                  </Button>
                </div>
              </>
            )}
          </MobileView>
        ) : (
          <>
            {selectedAppointment && isCancelled && (
              <ConfirmationDialogV2
                title={t("Cancel appointment?")}
                description={t("Are you sure you want to cancel this appointment?")}
                yesButtonLabel={t("Confirm")}
                noButtonLabel={t("Cancel")}
                onCancel={onDialogClosed}
                onConfirm={onDeleteConfirmed}
                open={isCancelled}
              >
                <>
                  {!hideRefundStatus && (
                    <div className="remove-member-confirmation">
                      <div className="message">{t('Refund policy')}</div>
                      <div className="refund-status">
                        {hideRefundStatus
                          ? ''
                          : refundDetails?.refundAmount
                          ? `${t('You will receive a refund of')} $${refundDetails?.refundAmount}, ${t('and it will take 5-10 days to appear on your statement.')}`
                          : t('You will not get any refund')}
                      </div>
                    </div>
                  )}
                  <div className="remove-member-confirmation1">
                    <p className="message">{t('Why this request is been cancelled?')}</p>
                    <textarea
                      id="description"
                      value={reviewMsg}
                      className="textarea-desc"
                      rows={5}
                      placeholder={t("Add Note...")}
                      maxLength={300}
                      onChange={handleTextareaChange}
                    />
                  </div>
                </>
              </ConfirmationDialogV2>
            )}
            {selectedAppointment && openTrxModal && (
              <ConfirmationDialogV2
                title={t("Transactions")}
                description={t("Are you sure you want to cancel this appointment?")}
                yesButtonLabel={t("Confirm")}
                noButtonLabel={t("Cancel")}
                onCancel={onDialogClosedTrx}
                onConfirm={onDeleteConfirmedTrx}
                open={openTrxModal}
              >
                <div className="remove-member-confirmation">
                  <TransactionList
                    transactions={selectedAppointment?.orders}
                    onRefetch={() => {
                      fetchEvents();
                      setOpenTrxModal(false);
                    }}
                  />
                </div>
              </ConfirmationDialogV2>
            )}
          </>
        )}
        {showPaymentDialog && selectedAppointment && (
          <PaymentRequest
            open={showPaymentDialog}
            onClose={() => {
              setPaymentDialog(false);
              fetchEvents();
            }}
            selectedAppointment={selectedAppointment}
            onConfirm={(lineItem:LineItem) => {
              fetchEvents();
              setPaymentDialog(false);
              setSelectedApptlineItem(lineItem);
              setShowPaymentCompletedModal(true);
            }}
            onBackToList={() => {
              onBackToList();
            }}
          />
        )}
        {showPaymentCompletedModal && selectedAppointment && (
          <PaymentCompletedModal
            open={showPaymentCompletedModal}
            onClose={() => {
              setShowPaymentCompletedModal(false);
              setSelectedApptlineItem({
                total: 0,
                advPayment: 0,
                serviceTip: 0,
                othCharges: 0,
                storeDisc: 0,
                subTotal: 0,
              });
            }}
            id={selectedAppointment.id as string}
            selectedAppointment={selectedAppointment}
            lineItem={selectedApptlineItem}
            onBackToList={() => {
              onBackToList();
              setShowPaymentCompletedModal(false);
              setSelectedApptlineItem({
                total: 0,
                advPayment: 0,
                serviceTip: 0,
                othCharges: 0,
                storeDisc: 0,
                subTotal: 0,
              });
              fetchEvents();
            }}
            roomBooking={selectedAppointment}
            paymentProvider={selectedAppointment?.paymentProvider}
           
          />
        )}
      </div>
    </section>
  );
}
